window.addEventListener('DOMContentLoaded', function () {
    const page = document.getElementById('js-users-list');
    if (!page) return;

    const deleteItemId = page.dataset.deleteItemId;
    const unlockItemId = page.dataset.unlockItemId;
    const deleteMsg = page.dataset.deleteMsg;
    const unlockMsg = page.dataset.unlockMsg;

    $(function () {
        clearFilters();
        confirmDialogs();

        function clearFilters() {
            $('#btn_filters_clear').on('click', function (e) {
                e.preventDefault();
                var form = $('#frm_list_filter');
                form.find("input[name='search_form[last_name]']").val('');
                form.find("input[name='search_form[first_name]']").val('');
                form.find("select[name='search_form[authorities]']").val('');
                form.find("input[name='search_form[delete_check]']").prop('checked', false);
            });
        }

        function confirmDialogs() {
            $("a[pid='" + deleteItemId + "']").on('click', async function (e) {
                e.preventDefault();
                const url = $(this).attr('href');
                if (url === '#') return;
                const result = await window.showConfirm(deleteMsg);
                if (result) {
                    window.location.href = url;
                }
            });

            $("a[pid='" + unlockItemId + "']").on('click', async function (e) {
                e.preventDefault();
                const url = $(this).attr('href');
                if (url === '#') return;
                const result = await window.showConfirm(unlockMsg);
                if (result) {
                    window.location.href = url;
                }
            });
        }
    });
});
